import { AxiosInstance, AxiosResponse } from "axios";
import { format } from "date-fns";
import axiosInstance from "./api-setup";
import {
  NewCarBooking,
  NewCarBookingSuccessResponse,
  RentalLocation,
  RentalPrice,
} from "./types";

class AutosApi {
  private readonly apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  public getPickupPlaces():
    | Promise<AxiosResponse<RentalLocation[]>>
    | undefined {
    return this.apiInstance.get("/car/places");
  }

  public getRentalPrices = async (
    pickupPlace: string,
    pickupDate: Date,
    dropoffDate: Date,
    ipAddress?: string
  ): Promise<AxiosResponse<RentalPrice[]>> => {
    return await this.apiInstance.post("/car/prices", {
      pickupDate: format(pickupDate, "yyyy-MM-dd"),
      dropoffDate: format(dropoffDate, "yyyy-MM-dd"),
      pickupPlace,
    });
  };

  public postNewBooking = async (
    data: NewCarBooking
  ): Promise<AxiosResponse<NewCarBookingSuccessResponse>> => {
    return this.apiInstance.post("/car", data);
  };
}

export default new AutosApi(axiosInstance);
